import PropTypes from "prop-types";
import { connect } from "react-redux";
import HeadMetadata from "app/utils/metas/HeadMetadata";
import { getRobotsMetaTag } from "app/reducers/partnerSelector";

const MerchandisingListingHeadMetadata = ({ robotsMetaTag, merchandisingLabel }) => {
	return (
		<HeadMetadata
			description="page.description.merch"
			title="page.title.merch"
			titleAttributes={{
				label: merchandisingLabel,
			}}
			robotsMetaTag={robotsMetaTag}
		/>
	);
};

MerchandisingListingHeadMetadata.propTypes = {
	robotsMetaTag: PropTypes.string,
	merchandisingLabel: PropTypes.string,
};

const mapStateToProps = state => {
	const robotsMetaTag = getRobotsMetaTag(state);
	return {
		robotsMetaTag: robotsMetaTag?.merch,
	};
};

export default connect(mapStateToProps)(MerchandisingListingHeadMetadata);
